import ErrorTemplate from "./ErrorTemplate";

export default function ServicesError() {
  return (
    <ErrorTemplate
      title="Sorry, we’re experiencing some issues"
      content="We’re working to resolve the issues as soon as possible. Please try again later."
    />
  );
}
